import { Table, TableHeader, TableBody, TableColumn, TableRow, TableCell, Input } from "@heroui/react";
import rawProperties from './properties.json';
import { useState, useMemo } from 'react';
import { filter } from "fuzzy";
import { IoSearchOutline } from "react-icons/io5";

const properties = rawProperties.map((property) => {
  const status = {
    'C': 'Contributor',
    'NC': 'Non-contributor',
    'C*': 'Contributor (Borderline)',
    'NC*': 'Non-contributor (Borderline)',
  }

  return {
    parcel: property.parcel,
    address: property.address,
    status: status[property.status],
    phase: property.phase,
  };
})

export function PropertyTable() {
  const [search, setSearch] = useState("");

  const [sortDescriptor, setSortDescriptor] = useState({
    column: "parcel",
    direction: "ascending",
  });

  const filteredProperties = useMemo(() => {
    if (search === "") {
      return properties;
    }

    return filter(search, properties, {
      extract: (property) => property.address,
    }).map((result) => result.original);
  }, [search]);

  const sortedProperties = useMemo(() => {
    return [...filteredProperties].sort((a, b) => {
      const first = a[sortDescriptor.column];
      const second = b[sortDescriptor.column];
      const cmp = first < second ? -1 : first > second ? 1 : 0;

      return sortDescriptor.direction === "descending" ? -cmp : cmp;
    });
  }, [sortDescriptor, filteredProperties]);

  return (
    <div className="w-full">
      <div className="mb-4">
        <Input
          type="text"
          placeholder="Search address..."
          value={search}
          onValueChange={setSearch}
          className="max-w-xs"
          startContent={<IoSearchOutline />}
        />
      </div>

      <Table
          aria-label="Properties table"
          sortDescriptor={sortDescriptor}
          onSortChange={setSortDescriptor}>
        <TableHeader>
          <TableColumn className="hidden sm:table-cell w-1/4" key="parcel" allowsSorting>PARCEL</TableColumn>
          <TableColumn className="w-1/4" key="address" allowsSorting>ADDRESS</TableColumn>
          <TableColumn className="w-1/4" key="status" allowsSorting>STATUS</TableColumn>
          <TableColumn className="hidden sm:table-cell w-1/4" key="phase" allowsSorting>PHASE</TableColumn>
        </TableHeader>
        <TableBody>
          {sortedProperties.map((property) => (
            <TableRow key={property.parcel}>
              <TableCell className="hidden sm:table-cell" key="parcel">{property.parcel}</TableCell>
              <TableCell key="address">{property.address}</TableCell>
              <TableCell key="status">{property.status}</TableCell>
              <TableCell className="hidden sm:table-cell" key="phase">Windsor Park&nbsp;{property.phase}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}